import { css } from '@emotion/react'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'

const GlobalStyles = css`
    * {
        font-family: Roboto, sans-serif;
        font-weight: 200;
    }
`
export default GlobalStyles
